import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'classlist.js';
import 'core-js/es/map';
import 'core-js/es/set';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom"
import { Provider } from 'react-redux';
import 'animate.css';
import Store from './redux/Store';
import './index.css';
import './sass/main.scss';
import './fonts/AvenirLTStd-Black.otf';
import './fonts/AvenirLTStd-Roman.otf';
import App from './App';
import {MaintenancePage} from './MaintenancePage';
import 'react-notifications-component/dist/theme.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <Provider store={Store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

